export default {"src":"/_next/static/media/trophy.96609e0a.svg","height":28,"width":28};